/**
 * Displays or hides a preloader.
 *
 * @param {boolean} start - Indicates whether to start or stop the preloader.
 */
const preloader = (start) => {
  let preloaderEl = document.querySelector(".xmlPreloader")
  if (start) {
    if (!preloaderEl) {
      preloaderEl = document.createElement("div")
      preloaderEl.className = "xmlPreloader"
      preloaderEl.innerHTML = `
          <div class="xmlPreloader__content">
            <span></span><span></span><span></span><span></span>
          </div>`
      document.body.appendChild(preloaderEl)
    }
    preloaderEl.style.display = "block"
    preloaderEl.style.opacity = 0
    requestAnimationFrame(() => {
      preloaderEl.style.transition = "opacity 0.4s"
      preloaderEl.style.opacity = 1
    })
  } else if (preloaderEl) {
    preloaderEl.style.transition = "opacity 0.4s"
    preloaderEl.style.opacity = 0
    setTimeout(() => {
      preloaderEl.style.display = "none"
    }, 400) // Assuming the fade out duration is 400ms
  }
}

export default preloader
